var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import PropTypes from 'prop-types';
import CategoryItem2 from './CategoryItem2';
import { target } from 'react-aim';
// @ts-ignore
let CategoryItem2List = class CategoryItem2List extends React.Component {
    render() {
        let { name, displayCategoryId, children } = this.props.productCategory;
        let catId = '' + displayCategoryId;
        if (catId.length == 1) {
            catId = '0' + catId;
        }
        let className = `categorySecondLayer cat${catId}`;
        let rows = children.map((productCategory, index) => {
            return (React.createElement(CategoryItem2, { key: index, parentDisplayCategoryId: displayCategoryId, productCategory: productCategory, disableMarketplaceBanner: this.props.disableMarketplaceBanner }));
        });
        return (React.createElement("div", { className: className },
            React.createElement("p", { className: "name" }, name),
            rows));
    }
};
CategoryItem2List.propTypes = {
    productCategory: PropTypes.shape({
        name: PropTypes.string.isRequired,
        displayCategoryId: PropTypes.number.isRequired,
        itemCount: PropTypes.number.isRequired,
        disableMarketplaceBanner: PropTypes.bool,
        children: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string.isRequired,
            displayCategoryId: PropTypes.number.isRequired,
            itemCount: PropTypes.number.isRequired,
        })).isRequired,
    }),
};
CategoryItem2List = __decorate([
    target()
], CategoryItem2List);
export default CategoryItem2List;
